
export default [
  // SWA
  {
    path: "/qspiSWA",
    name:"SCHR",
    component: () =>
      import("@/components/page/QSPI/OtherTargetMaintain/SWA"),
    meta: { title: "SCHR" },
  },
  // SQMS
  {
    path: "/qspiSQMS",
    name:"SQMS",
    component: () =>
      import("@/components/page/QSPI/OtherTargetMaintain/otherSqms"),
    meta: { title: "SQMS" },
  },
  // Gov't Cert
  {
    path: "/qspiGovtCert",
    name:"govtCert",
    component: () =>
      import("@/components/page/QSPI/OtherTargetMaintain/GovtCert"),
    meta: { title: "Gov't Cert" },
  },
  // Spec Compliance
  {
    path: "/qspiSpecCompliance",
    name:"specCompliance",
    component: () =>
      import("@/components/page/QSPI/OtherTargetMaintain/specCompliance"),
    meta: { title: "Spec Compliance" },
  },
  // COA
  {
    path: "/qspiCOA",
    name:"COA",
    component: () =>
      import("@/components/page/QSPI/OtherTargetMaintain/COA"),
    meta: { title: "COA" },
  },
  // Reg Compliance
  {
    path: "/qspiRegCompliance",
    name:"regCompliance",
    component: () =>
      import("@/components/page/QSPI/OtherTargetMaintain/RegCompliance"),
    meta: { title: "Reg Compliance" },
  },
  // Gov't Plant Audit
  {
    path: "/qspiGovtPlantAudit",
    name:"govtPlantAudit",
    component: () =>
      import("@/components/page/QSPI/OtherTargetMaintain/GovtPlantAudit"),
    meta: { title: "Gov't Plant Audit" },
  },
  // Stock Recovery
  {
    path: "/qspiOtherStockRecovery",
    name:"stockRecovery",
    component: () =>
      import("@/components/page/QSPI/OtherTargetMaintain/StockRecovery"),
    meta: { title: "Stock Recovery" },
  },
  // Product Feedback
  {
    path: "/qspiProductFeedback",
    name:"productFeedback",
    component: () =>
      import("@/components/page/QSPI/OtherTargetMaintain/ProductFeedback"),
    meta: { title: "Product Feedback" },
  },
  // Sensory
  {
    path: "/qspiSensory",
    name:"sensory",
    component: () =>
      import("@/components/page/QSPI/OtherTargetMaintain/Sensory"),
    meta: { title: "Sensory" },
  },
  // MSV
  {
    path: "/qspiMSV",
    name:"MSV",
    component: () =>
      import("@/components/page/QSPI/OtherTargetMaintain/MSV"),
    meta: { title: "MSV" },
  },
  // qspiAntiChick
  {
    path: "/qspiAntiChick",
    name:"antiChick",
    component: () =>
      import("@/components/page/QSPI/OtherTargetMaintain/antiChicken"),
    meta: { title: "Antibiotic Chicken" },
  },
  // qspiOtherQIP
  {
    path: "/qspiOtherQIP",
    name:"qip",
    component: () =>
      import("@/components/page/QSPI/OtherTargetMaintain/QIP"),
    meta: { title: "QIP" },
  },
  {
    path: "/qspiOtherQBR",
    name:"qbr",
    component: () =>
      import("@/components/page/QSPI/OtherTargetMaintain/QBR"),
    meta: { title: "QBR" },
  },
  {
    path: "/qspiCommon/detail",
    name:"qspiOtherDetail",
    component: () =>
      import("@/components/page/QSPI/OtherTargetMaintain/MaintainScoreTask"),
    meta: { title: "评分" },
  },
];
